import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Flask, Truck, MapPin, Confetti, Medal, SealCheck, Heart } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { BeerCard } from "../components/BeerCard";
import { Marquee } from "../components/Marquee";
import { NemesisBanner } from "../components/NemesisBanner";
import { RamonaBanner } from "../components/RamonaBanner";
import { ImportadasShowcase } from "../components/ImportadasShowcase";
import { ExclusivasVideo } from "../components/ExclusivasVideo";
import { PotterVideo } from "../components/PotterVideo";
import { FadeCarousel } from "../components/FadeCarousel";

const HERO_LOGO = "https://customer-assets.emergentagent.com/job_hoppy-local-imports/artifacts/zpmo2he9_IMG_20260628_113918.jpg";
const ABOUT_IMG = "https://customer-assets-eiarnc6j.emergentagent.net/job_hoppy-local-imports/artifacts/fgmbgqm5_IMG_20260730_173445.png";
const CICERONE_CERT = "https://customer-assets-eiarnc6j.emergentagent.net/job_hoppy-local-imports/artifacts/1k1mwqiq_1785447342501.png";
const EISEN_POSTER = "https://customer-assets-eiarnc6j.emergentagent.net/job_hoppy-local-imports/artifacts/7011f805f2833cb4_1791580608020.jpg";
const CATA_HOME_IMG = "https://static.prod-images.emergentagent.com/jobs/f4d02145-fcf7-41ef-be94-47907979e0b0/images/696b792ae0a315d3f8f63f93ba3dbc4d815095f7c01f26f8246416f1ff7bdee1.jpeg";

const stats = [
  { n: "+15", l: "Años haciendo cerveza" },
  { n: "2", l: "Años como Ciudad Garaje" },
  { n: "20+", l: "Cervezas" },
  { n: "100%", l: "Artesanal" },
];

const features = [
  { icon: Flask, t: "Artesanal", d: "Lotes pequeños fermentados con carácter de taller. Recetas propias y ediciones limitadas." },
  { icon: Truck, t: "Importadas", d: "Clásicos de Bélgica, Alemania, Irlanda y más, seleccionados uno por uno." },
  { icon: MapPin, t: "Nacionales", d: "Lo mejor de Venezuela, de las grandes clásicas a joyas regionales." },
];

const CAMPO = [
  { tipo: "cerveza", t: "Cerveza", d: "Cervezas artesanales GARAJE", img: "https://customer-assets.emergentagent.com/job_hoppy-local-imports/artifacts/ythj427l_IMG_20260710_233911.jpg", query: "tipo=cerveza&cat=artesanal" },
  { tipo: "importada", t: "Importadas", d: "Cerveza del mundo, seleccionada", img: "https://images.unsplash.com/photo-1507310951869-fe0941df4dbd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", query: "tipo=cerveza&cat=importada" },
  { tipo: "boutique", t: "Boutique de Garaje", d: "Ropa, cristalería, packs de regalo y té", img: "https://static.prod-images.emergentagent.com/jobs/f4d02145-fcf7-41ef-be94-47907979e0b0/images/535b600648a49deed35af335a908959cccdcf61d5f7a98ebb1cf8386889a692b.jpeg", query: "tipo=boutique" },
];

const BRAND_SLIDES = [
  "https://customer-assets-eiarnc6j.emergentagent.net/job_hoppy-local-imports/artifacts/96agajeo_IMG_20260930_095105.webp",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_hoppy-local-imports/artifacts/dgerirl9_IMG_20260930_094959.png",
];
const ANNIVERSARY_LOGO = "https://customer-assets.emergentagent.com/job_hoppy-local-imports/artifacts/1eov5af6_1783877329651.png";

export default function Home() {
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    api.get("/beers").then((res) => setFeatured(res.data.filter((b) => b.featured).slice(0, 4)));
  }, []);

  return (
    <div>
      {/* HERO */}
      <section className="relative grain min-h-[92vh] flex items-center overflow-hidden bg-[#0A0A0A]" data-testid="hero-section">
        <img src={HERO_LOGO} alt="Logo GARAJE" className="absolute right-0 md:right-[4%] top-1/2 -translate-y-1/2 h-[55%] sm:h-[70%] md:h-[85%] w-auto object-contain opacity-20 md:opacity-30 pointer-events-none select-none" />
        <div
          data-testid="anniversary-logo"
          className="absolute top-4 right-4 md:top-6 md:right-6 z-20 w-24 sm:w-28 md:w-36 aspect-square rounded-full overflow-hidden drop-shadow-[0_2px_14px_rgba(0,0,0,0.75)] select-none pointer-events-none"
        >
          <img src={ANNIVERSARY_LOGO} alt="2° Aniversario Ciudad Garaje" className="w-full h-full object-cover scale-[1.12]" />
        </div>
        <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 72% 50%, rgba(217,119,54,0.14), transparent 55%)" }} />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]/30" />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8 w-full">
          <div
            className="max-w-3xl"
          >
            <div className="overline text-[#F5A623] mb-5">Cervecería artesanal · Calidad en cada sorbo</div>
            <h1 className="font-display text-6xl sm:text-7xl lg:text-8xl leading-[0.92]">
              Es cerveza,<br />es <span className="text-[#D97736]">arte</span>
            </h1>
            <p className="text-gray-300 text-base md:text-lg mt-6 max-w-xl leading-relaxed">
              Cerveza artesanal de la más alta calidad, nacionales e importadas del mundo, y la Boutique de Garaje: del producto a tu boca, sin concesiones.
            </p>
            <div className="flex flex-wrap gap-4 mt-9">
              <Link
                to="/catalogo"
                className="flex items-center gap-2 bg-[#D97736] hover:bg-[#E88D50] text-black font-semibold uppercase tracking-wide px-7 py-4 transition-colors hover:-translate-y-0.5"
                style={{ transitionProperty: "background-color, transform" }}
                data-testid="hero-shop-btn"
              >
                Ver catálogo <ArrowRight size={18} weight="bold" />
              </Link>
              <a
                href="#nosotros"
                className="flex items-center gap-2 border border-white/25 hover:border-[#D97736] hover:text-[#D97736] uppercase tracking-wide px-7 py-4 transition-colors"
                data-testid="hero-about-btn"
              >
                Conócenos
              </a>
            </div>
          </div>
        </div>
      </section>

      <Marquee />

      <ExclusivasVideo />

      <NemesisBanner />

      <RamonaBanner />

      <ImportadasShowcase />

      {/* STATS */}
      <section className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {stats.map((s) => (
          <div key={s.l} className="bg-[#0A0A0A] p-8 text-center">
            <div className="font-display text-5xl text-[#D97736]">{s.n}</div>
            <div className="overline mt-2">{s.l}</div>
          </div>
        ))}
      </section>

      {/* MARCA GARAJE */}
      <section className="relative grain border-y border-white/10 bg-[#0d0d0d]" data-testid="brand-showcase">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div
            className="relative mx-auto w-full max-w-md"
          >
            <FadeCarousel
              images={[
                "https://customer-assets-eiarnc6j.emergentagent.net/job_hoppy-local-imports/artifacts/96agajeo_IMG_20260930_095105.webp",
                "https://customer-assets-eiarnc6j.emergentagent.net/job_hoppy-local-imports/artifacts/dgerirl9_IMG_20260930_094959.png",
              ]}
            />
          </div>

          <div>
            <div className="inline-flex items-center gap-2 border border-[#D97736]/50 text-[#F5A623] px-3 py-1.5 mb-6">
              <Medal size={16} weight="fill" /> <span className="overline text-[#F5A623]">Premiada · 43 puntos BJCP</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl leading-none">La mejor cerveza de Caracas</h2>
            <p className="text-gray-400 mt-5 max-w-lg">
              Nuestra cerveza GARAJE es única en su estilo y lo respaldan los jueces: <span className="text-white">43 puntos en la escala BJCP</span>. Calidad que se prueba, no que se promete.
            </p>
            <p className="text-gray-400 mt-4 max-w-lg">
              Tres estilos, un mismo estándar. <span className="text-[#D97736]">Ven y sé tú el primer juez.</span>
            </p>
            <Link
              to="/catalogo?tipo=cerveza"
              className="inline-flex items-center gap-2 mt-8 bg-[#D97736] hover:bg-[#E88D50] text-black font-semibold uppercase tracking-wide px-7 py-4 transition-colors hover:-translate-y-0.5"
              style={{ transitionProperty: "background-color, transform" }}
              data-testid="brand-cta"
            >
              Probar GARAJE <ArrowRight size={18} weight="bold" />
            </Link>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section id="nosotros" className="max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-5 relative grain">
          <img src={ABOUT_IMG} alt="Proceso artesanal" className="w-full aspect-[4/5] object-cover border border-white/10" />
        </div>
        <div className="md:col-span-7">
          <div className="overline text-[#F5A623] mb-3">Nuestra casa</div>
          <h2 className="font-display text-5xl md:text-6xl leading-none">Tres mundos, una barra</h2>
          <p className="text-gray-400 mt-5 max-w-xl">
            En Ciudad Garaje mezclamos la crudeza industrial con el arte de la fermentación. Cada lata y botella pasa por nuestro filtro: que valga la pena abrirla.
          </p>
          <p className="text-gray-400 mt-4 max-w-xl">
            Somos Ciudad Garaje desde hace <span className="text-white font-medium">2 años</span>, pero llevamos <span className="text-[#D97736] font-medium">más de 15 años haciendo cerveza</span>. Esa experiencia es la que hoy garantiza la calidad de cada producto.
          </p>
          <div className="mt-10 space-y-px bg-white/10 border border-white/10">
            {features.map((f) => (
              <div key={f.t} className="bg-[#141414] p-6 flex gap-5 items-start hover:bg-[#1a1a1a] transition-colors">
                <div className="w-12 h-12 border border-[#D97736]/50 flex items-center justify-center text-[#D97736] shrink-0">
                  <f.icon size={24} weight="duotone" />
                </div>
                <div>
                  <h3 className="font-display text-2xl">{f.t}</h3>
                  <p className="text-gray-400 text-sm mt-1">{f.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CAMPO A LA BOCA */}
      <section className="max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-20">
        <div className="mb-10 max-w-2xl">
          <div className="overline text-[#F5A623] mb-3">Calidad artesanal · del producto a tu boca</div>
          <h2 className="font-display text-5xl md:text-6xl leading-none">Más que cerveza</h2>
          <p className="text-gray-400 mt-4">
            Nuestra cerveza artesanal es el arte; las importadas del mundo y la Boutique de Garaje, nuestra obsesión por la calidad. Cada producto se selecciona con cuidado, del origen hasta tu paladar.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {CAMPO.map((c) => (
            <Link
              key={c.tipo}
              to={`/catalogo?${c.query}`}
              className="group relative aspect-[3/4] overflow-hidden bg-[#141414]"
              data-testid={`campo-${c.tipo}`}
            >
              <img src={c.img} alt={c.t} className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 p-6">
                <h3 className="font-display text-3xl">{c.t}</h3>
                <p className="text-gray-300 text-sm mt-1">{c.d}</p>
                <span className="inline-flex items-center gap-2 mt-3 text-[#D97736] uppercase tracking-widest text-xs group-hover:gap-3 transition-all">
                  Ver <ArrowRight size={14} weight="bold" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* FEATURED */}
      {featured.length > 0 && (
        <section className="max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-20">
          <div className="flex items-end justify-between mb-10">
            <div>
              <div className="overline text-[#F5A623] mb-2 flex items-center gap-2"><Confetti size={16} weight="fill" /> Selección de la casa</div>
              <h2 className="font-display text-5xl md:text-6xl leading-none">Destacadas</h2>
            </div>
            <Link to="/catalogo" className="hidden md:flex items-center gap-2 text-[#D97736] uppercase tracking-widest text-sm hover:gap-3 transition-all">
              Ver todas <ArrowRight size={16} weight="bold" />
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {featured.map((b, i) => (
              <BeerCard key={b.id} beer={b} index={i} />
            ))}
          </div>
        </section>
      )}

      <PotterVideo />

      {/* CATA PRIVADA BANNER */}
      <section className="border-y border-white/10 bg-[#141414]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-5 max-w-2xl">
            <img
              src={CATA_HOME_IMG}
              alt="Vive una cata privada"
              className="hidden sm:block w-20 md:w-24 aspect-[3/4] object-cover border border-white/10 shrink-0"
              data-testid="home-cata-thumb"
            />
            <div>
              <div className="overline text-[#F5A623] mb-1">Nueva experiencia</div>
              <h2 className="font-display text-4xl md:text-5xl leading-none">Vive una cata privada</h2>
              <p className="text-gray-400 mt-2">Llevamos todas nuestras cervezas a tu evento. Ideal para empresas, fiestas corporativas y cumpleaños.</p>
            </div>
          </div>
          <Link to="/cata-privada" className="flex items-center gap-2 bg-[#D97736] hover:bg-[#E88D50] text-black font-semibold uppercase tracking-wide px-7 py-4 transition-colors hover:-translate-y-0.5 shrink-0" style={{ transitionProperty: "background-color, transform" }} data-testid="home-cata-cta">
            Reservar cata <ArrowRight size={18} weight="bold" />
          </Link>
        </div>
      </section>

      {/* CERTIFICACIÓN CICERONE */}
      <section className="relative grain border-t border-white/10 bg-[#0d0d0d]" data-testid="cicerone-section">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 md:order-1">
            <div className="inline-flex items-center gap-2 border border-[#D97736]/50 text-[#F5A623] px-3 py-1.5 mb-6">
              <SealCheck size={16} weight="fill" /> <span className="overline text-[#F5A623]">Certificación oficial</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl leading-none">
              Cicerone® <span className="text-[#D97736]">Certified Beer Server</span>
            </h2>
            <p className="text-gray-400 mt-5 max-w-lg">
              En Ciudad Garaje no solo hacemos cerveza: la servimos como se debe. Contamos con la certificación <span className="text-white">Cicerone® Certified Beer Server</span>, el aval internacional que garantiza el correcto almacenamiento, tiraje y servicio de cada cerveza.
            </p>
            <p className="text-gray-400 mt-4 max-w-lg">
              Es nuestro compromiso con la calidad: <span className="text-[#D97736]">del barril a tu vaso, en su punto perfecto.</span>
            </p>
          </div>
          <div className="order-1 md:order-2 flex justify-center">
            <img
              src={CICERONE_CERT}
              alt="Certificado Cicerone Certified Beer Server - Craftbeer Academy GARAJE"
              className="w-full max-w-xs md:max-w-sm border border-white/10 shadow-2xl shadow-black/50"
              data-testid="cicerone-cert-img"
            />
          </div>
        </div>
      </section>

      {/* DISTRIBUIDOR AUTORIZADO EISEN */}
      <section className="relative grain border-t border-white/10 bg-[#0A0A0A]" data-testid="eisen-section">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="flex justify-center md:justify-start">
            <img
              src={EISEN_POSTER}
              alt="Ciudad Garaje · Distribuidor autorizado de cerveza artesanal EISEN Margarita: Patada e' Burro Imperial Stout, Rubia Extra Especial y IPA"
              className="w-full max-w-[150px] md:max-w-[180px] border border-[#F5A623]/25 shadow-lg shadow-black/40"
              data-testid="eisen-poster-img"
            />
          </div>
          <div>
            <div className="inline-flex items-center gap-2 border border-[#D97736]/50 text-[#F5A623] px-3 py-1.5 mb-6">
              <SealCheck size={16} weight="fill" /> <span className="overline text-[#F5A623]">Distribuidor autorizado</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl leading-none">
              Cerveza <span className="text-[#D97736]">EISEN Margarita</span>
            </h2>
            <p className="text-gray-400 mt-5 max-w-lg">
              Somos <span className="text-white">distribuidor autorizado</span> de la cervecería artesanal EISEN Margarita. Encuentra sus etiquetas <span className="text-white">100% naturales</span>: Patada e' Burro (Imperial Stout), Rubia (Extra Especial) e IPA.
            </p>
            <p className="text-gray-400 mt-4 max-w-lg">
              Cómpralas en <span className="text-[#D97736]">www.ciudad-garaje.com</span> o en los locales GARAJE.
            </p>
            <Link
              to="/catalogo?tipo=cerveza"
              className="inline-flex items-center gap-2 mt-8 bg-[#D97736] hover:bg-[#E88D50] text-black font-semibold uppercase tracking-wide px-7 py-4 transition-colors hover:-translate-y-0.5"
              style={{ transitionProperty: "background-color, transform" }}
              data-testid="eisen-cta"
            >
              Ver cervezas <ArrowRight size={18} weight="bold" />
            </Link>
          </div>
        </div>
      </section>

      {/* CERVEZA SOLIDARIA · ANTICÁNCER */}
      <section className="relative grain border-t border-white/10 bg-[#0d0d0d] overflow-hidden" data-testid="solidaria-section">
        <div
          className="absolute inset-0 opacity-[0.12] pointer-events-none"
          style={{ background: "linear-gradient(120deg, #E8679E 0%, transparent 45%, transparent 55%, #5BA4D6 100%)" }}
        />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 md:order-1">
            <div className="inline-flex items-center gap-2 border border-[#E8679E]/50 text-[#F2A9C8] px-3 py-1.5 mb-6">
              <Heart size={16} weight="fill" /> <span className="overline text-[#F2A9C8]">Cerveza solidaria</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl leading-none">
              Juntos en la lucha, <span className="text-[#E8679E]">prevenir</span> es <span className="text-[#5BA4D6]">vivir</span>
            </h2>
            <p className="text-gray-400 mt-5 max-w-lg">
              Nuestra cerveza solidaria estilo Pale se suma a dos causas: <span className="text-[#F2A9C8] font-medium">Octubre Rosa</span>, por la prevención del cáncer de mama (Tócate), y <span className="text-[#9CCBEC] font-medium">Noviembre Azul</span>, por la salud del hombre (Cuídate).
            </p>
            <p className="text-gray-400 mt-4 max-w-lg">
              Brindar también es concientizar. <span className="text-white">Chequéate a tiempo: detectar temprano salva vidas.</span>
            </p>
            <div className="flex flex-wrap gap-6 mt-7">
              <div className="flex items-center gap-2 text-sm text-gray-300"><span className="w-3 h-3 rounded-full bg-[#E8679E]" /> Octubre Rosa · Tócate</div>
              <div className="flex items-center gap-2 text-sm text-gray-300"><span className="w-3 h-3 rounded-full bg-[#5BA4D6]" /> Noviembre Azul · Cuídate</div>
            </div>
            <div className="mt-6 overline text-gray-500">Estilo Pale · 5% vol. · 330 ml · Venezuela</div>
          </div>
          <div className="order-1 md:order-2 flex justify-center">
            <img
              src="/solidaria-label.png"
              alt="Cerveza GARAJE solidaria estilo Pale · Octubre Rosa y Noviembre Azul · Juntos en la lucha, prevenir es vivir"
              className="w-full max-w-md drop-shadow-2xl"
              data-testid="solidaria-label-img"
            />
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative grain border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-20 text-center md:text-left flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <h2 className="font-display text-5xl md:text-6xl leading-none">¿Sed de algo distinto?</h2>
            <p className="text-gray-400 mt-3">Explora más de 20 etiquetas y arma tu propia caja.</p>
          </div>
          <Link
            to="/catalogo"
            className="flex items-center gap-2 bg-[#D97736] hover:bg-[#E88D50] text-black font-semibold uppercase tracking-wide px-8 py-4 transition-colors hover:-translate-y-0.5"
            style={{ transitionProperty: "background-color, transform" }}
          >
            Comprar ahora <ArrowRight size={18} weight="bold" />
          </Link>
        </div>
      </section>
    </div>
  );
}
